import { statusFillColor, statusStrokeColor } from '@/components/system/colors.ts'

const pinSvg = (fillColor: string, strokeColor: string, strokeWidth = 1): string => `
<svg width="32" height="34" viewBox="0 0 32 34" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_745_8889)">
    <path
        d="M29 11.4545C29 20.3636 16 28 16 28C16 28 3 20.3636 3 11.4545C3 8.41661 4.36964 5.5031 6.80761 3.35496C9.24558 1.20681 12.5522 0 16 0C19.4478 0 22.7544 1.20681 25.1924 3.35496C27.6304 5.5031 29 8.41661 29 11.4545Z"
        fill="white"
    />
    <path
        d="M28.5 11.4545C28.5 15.6834 25.3965 19.6914 22.1595 22.7021C20.5558 24.1936 18.95 25.4122 17.7441 26.2583C17.1416 26.681 16.6401 27.01 16.2902 27.2326C16.177 27.3047 16.0797 27.3656 16 27.4149C15.9203 27.3656 15.823 27.3047 15.7098 27.2326C15.3599 27.01 14.8584 26.681 14.2559 26.2583C13.05 25.4122 11.4442 24.1936 9.84052 22.7021C6.60351 19.6914 3.5 15.6834 3.5 11.4545C3.5 8.57111 4.79944 5.7908 7.13816 3.73011C9.47892 1.66762 12.6658 0.5 16 0.5C19.3342 0.5 22.5211 1.66762 24.8618 3.73011C27.2006 5.7908 28.5 8.57111 28.5 11.4545Z"
        stroke="white"
    />
  </g>
  <path
      d="M28.5 11.4545C28.5 15.6834 25.3965 19.6914 22.1595 22.7021C20.5558 24.1936 18.95 25.4122 17.7441 26.2583C17.1416 26.681 16.6401 27.01 16.2902 27.2326C16.177 27.3047 16.0797 27.3656 16 27.4149C15.9203 27.3656 15.823 27.3047 15.7098 27.2326C15.3599 27.01 14.8584 26.681 14.2559 26.2583C13.05 25.4122 11.4442 24.1936 9.84052 22.7021C6.60351 19.6914 3.5 15.6834 3.5 11.4545C3.5 8.57111 4.79944 5.7908 7.13816 3.73011C9.47892 1.66762 12.6658 0.5 16 0.5C19.3342 0.5 22.5211 1.66762 24.8618 3.73011C27.2006 5.7908 28.5 8.57111 28.5 11.4545Z"
      fill="${fillColor}"
      stroke="${strokeColor}"
      stroke-width="${strokeWidth}"
  />
  <defs>
    <filter
        id="filter0_d_745_8889"
        x="0"
        y="0"
        width="32"
        height="34"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
      <feOffset dy="3" />
      <feGaussianBlur stdDeviation="1.5" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0" />
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_745_8889" />
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_745_8889" result="shape" />
    </filter>
  </defs>
</svg>
`

const flagSvg = (fillColor: string, strokeColor: string): string => `
<svg width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M3.5 24.3677V2.21348C3.54178 2.17733 3.59438 2.13406 3.65849 2.08522C3.87594 1.91954 4.22695 1.68888 4.73913 1.45474C5.76186 0.987202 7.44011 0.5 10 0.5C12.5616 0.5 14.6982 0.986767 16.8886 1.48743L16.9055 1.4913C19.0848 1.98942 21.3186 2.5 24 2.5C26.6901 2.5 28.5119 1.9872 29.6766 1.45474C30.0017 1.30615 30.2745 1.15648 30.5 1.01681V23.7865C30.4582 23.8227 30.4056 23.8659 30.3415 23.9148C30.1241 24.0805 29.773 24.3111 29.2609 24.5453C28.2381 25.0128 26.5599 25.5 24 25.5C21.476 25.5 19.5251 24.7721 17.4938 24.0101L17.471 24.0016C15.4525 23.2444 13.3521 22.4565 10.6364 22.4565C7.93106 22.4565 5.94759 23.0845 4.63093 23.7242C4.17331 23.9465 3.79719 24.1698 3.5 24.3677ZM30.6264 23.6677L30.6263 23.6678L30.6264 23.6677Z"
    fill="white"
    stroke="white"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <g filter="url(#filter0_d_745_8889)">
    <path
      d="M3 25.3913C3 25.3913 5.38636 22.9565 10.6364 22.9565C15.8864 22.9565 18.75 26 24 26C29.25 26 31 24 31 24V0C31 0 29.25 2 24 2C18.75 2 15.25 0 10 0C4.75 0 3 2 3 2V25.3913Z"
      fill="${fillColor}"
    />
    <path
      d="M3.5 24.3677V2.21348C3.54178 2.17733 3.59438 2.13406 3.65849 2.08522C3.87594 1.91954 4.22695 1.68888 4.73913 1.45474C5.76186 0.987202 7.44011 0.5 10 0.5C12.5616 0.5 14.6982 0.986767 16.8886 1.48743L16.9055 1.4913C19.0848 1.98942 21.3185 2.5 24 2.5C26.6901 2.5 28.5119 1.9872 29.6766 1.45474C30.0017 1.30615 30.2745 1.15648 30.5 1.01681V23.7865C30.4582 23.8227 30.4056 23.8659 30.3415 23.9148C30.1241 24.0805 29.773 24.3111 29.2609 24.5453C28.2381 25.0128 26.5599 25.5 24 25.5C21.476 25.5 19.5251 24.7721 17.4938 24.0101L17.471 24.0016C15.4525 23.2444 13.3521 22.4565 10.6364 22.4565C7.93106 22.4565 5.94759 23.0845 4.63093 23.7242C4.17331 23.9465 3.79719 24.1698 3.5 24.3677Z"
      stroke="${strokeColor}"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <defs>
    <filter
        id="filter0_d_745_8889"
        x="0"
        y="0"
        width="34"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
      <feOffset dy="3" />
      <feGaussianBlur stdDeviation="1.5" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0" />
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_745_8889" />
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_745_8889" result="shape" />
    </filter>
  </defs>
</svg>
`

const diamondSvg = (): string => `
<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.7399 0.521962C17.4358 -0.173987 18.5642 -0.173987 19.2601 0.521962L35.478 16.7399C36.174 17.4358 36.174 18.5642 35.478 19.2601L19.2601 35.478C18.5642 36.174 17.4358 36.174 16.7399 35.478L0.521962 19.2601C-0.173987 18.5642 -0.173987 17.4358 0.521962 16.7399L16.7399 0.521962Z" fill="white"/>
<path d="M16.7399 0.521962C17.4358 -0.173987 18.5642 -0.173987 19.2601 0.521962L35.478 16.7399C36.174 17.4358 36.174 18.5642 35.478 19.2601L19.2601 35.478C18.5642 36.174 17.4358 36.174 16.7399 35.478L0.521962 19.2601C-0.173987 18.5642 -0.173987 17.4358 0.521962 16.7399L16.7399 0.521962Z" fill="black"/>
</svg>
`

const completedSvg = (): string => `
<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_2718_26513)">
    <g filter="url(#filter0_d_2718_26513)">
      <circle cx="18" cy="16" r="15" fill="white"/>
      <circle cx="18" cy="16" r="14.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <circle cx="18" cy="16" r="14.5" fill="#0E9F6E" stroke="#014737" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M24.3077 11L15.8462 20.8462L12 16.3706" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <filter id="filter0_d_2718_26513" x="0" y="1" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="3"/>
      <feGaussianBlur stdDeviation="1.5"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2718_26513"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2718_26513" result="shape"/>
    </filter>
    <clipPath id="clip0_2718_26513">
      <rect width="36" height="36" fill="white"/>
    </clipPath>
  </defs>
</svg>
`

export const svgPinMarker = (status: 'pending' | 'allocated' | 'assigned' | 'onboarded') => {
  switch (status) {
    case 'pending':
      return diamondSvg()
    case 'assigned':
      return pinSvg(statusFillColor(status), statusStrokeColor(status), 2)
    default:
      return pinSvg(statusFillColor(status), statusStrokeColor(status))
  }
}

export const svgRequestMarker = (status: 'pending' | 'allocated' | 'assigned' | 'onboarded' | 'completed') => {
  switch (status) {
    case 'onboarded':
      return flagSvg(statusFillColor(status), statusStrokeColor(status))
    case 'completed':
      return completedSvg()
    default:
      return svgPinMarker(status)
  }
}
